export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  date: string;
  readTime: string;
  isHot: boolean;
  isNew: boolean;
}

export const categoryInfo: Record<string, { name: string; description: string; icon: string }> = {
  "latest-url": {
    name: "最新地址",
    description: "获取爱情岛最新官方入口及备用访问地址，确保每次都能顺利访问平台",
    icon: "ri-link",
  },
  "guide": {
    name: "使用指南",
    description: "详细的爱情岛平台使用教程，从注册到高级功能，手把手教你玩转爱情岛",
    icon: "ri-guide-line",
  },
  "faq": {
    name: "常见问题",
    description: "汇总用户最常遇到的问题及解决方案，快速找到你需要的答案",
    icon: "ri-question-answer-line",
  },
  "safety": {
    name: "安全建议",
    description: "网络安全防护指南，帮你识别钓鱼网站，保护个人信息和账户安全",
    icon: "ri-shield-check-line",
  },
};

export const articles: Article[] = [
  {
    id: "art-1",
    slug: "latest-official-url-2024-december",
    title: "爱情岛官方网址2024年12月最新入口更新",
    excerpt: "本文提供爱情岛2024年12月最新官方入口地址及备用访问链接，确保用户能够顺利访问平台全部功能。",
    content: `<h2>爱情岛2024年12月官方入口更新说明</h2>
<p>由于近期网络环境调整，爱情岛官方访问入口已进行更新。为确保广大用户能够继续顺畅地使用平台服务，我们第一时间对所有访问地址进行了全面更新和验证。</p>
<h3>最新官方入口</h3>
<p>目前爱情岛官方主入口为：<strong>https://www.aiqingdao.com</strong>，该地址已经过全面测试，确保在全国主要网络环境下均可正常访问。</p>
<h3>备用访问地址</h3>
<p>为应对不同网络环境下的访问需求，我们提供了以下备用地址：</p>
<ul>
<li>备用地址一：https://aiqingdao1.com</li>
<li>备用地址二：https://aiqingdao2.com</li>
<li>备用地址三：https://aiqingdao3.com</li>
</ul>
<p>以上备用地址与官方入口功能完全一致，用户可根据自身网络情况选择合适的地址进行访问。</p>
<h3>访问建议</h3>
<p>建议用户将本导航页面加入浏览器收藏夹，以便随时获取最新有效的访问地址。同时，建议在访问前清除浏览器缓存，以获得最佳的访问体验。</p>`,
    category: "latest-url",
    date: "2024-12-15",
    readTime: "3分钟",
    isHot: true,
    isNew: true,
  },
  {
    id: "art-2",
    slug: "avoid-fake-websites-safety-guide",
    title: "如何识别和防范假冒爱情岛网址——安全指南",
    excerpt: "详细介绍识别假冒爱情岛网址的方法，以及保护个人账户安全的实用建议，让每次访问都安全无忧。",
    content: `<h2>防范假冒爱情岛网址的完整指南</h2>
<p>近期我们收到多起用户反馈，称在访问爱情岛时遇到了假冒网站。这些虚假网站不仅无法提供正常的平台服务，还可能窃取用户的个人信息和账户密码。本文将为您详细介绍如何识别和防范这类风险。</p>
<h3>假冒网站的常见特征</h3>
<p>假冒的爱情岛网址通常具有以下特征：</p>
<ul>
<li>网址拼写存在细微差异，如多一个字母或少一个字母</li>
<li>使用非HTTPS协议，浏览器地址栏无安全锁标识</li>
<li>页面设计粗糙，存在大量弹窗广告</li>
<li>要求用户下载不明来源的APP或插件</li>
<li>以"账号异常"等理由索要用户密码或验证码</li>
</ul>
<h3>如何确保访问的是官方网站</h3>
<p>最可靠的方式是通过本导航页提供的官方入口进行访问。本页所有链接均经过人工验证，确保指向的是爱情岛真实官方网站。同时请注意以下要点：</p>
<ul>
<li>检查浏览器地址栏是否有安全锁图标</li>
<li>核对网址是否与官方公布的一致</li>
<li>官方网站不会通过弹窗索要个人信息</li>
<li>如不确定，可通过官方客服渠道核实</li>
</ul>
<h3>遭遇假冒网站后的处理措施</h3>
<p>如果您怀疑自己访问了假冒网站，请立即采取以下措施：</p>
<ul>
<li>立即修改您的爱情岛账户密码</li>
<li>检查账户是否有异常登录记录</li>
<li>联系官方客服报告情况</li>
<li>如涉及资金安全，及时联系银行处理</li>
</ul>`,
    category: "safety",
    date: "2024-11-28",
    readTime: "5分钟",
    isHot: true,
    isNew: true,
  },
  {
    id: "art-3",
    slug: "aiqingdao-registration-tutorial",
    title: "爱情岛新用户注册与登录完整教程",
    excerpt: "从零开始，详细讲解爱情岛平台的注册流程、账号设置和首次登录注意事项，帮助新用户快速上手。",
    content: `<h2>爱情岛新用户注册与登录教程</h2>
<p>欢迎来到爱情岛！本文将为您详细讲解从注册到登录的每一步操作，帮助您快速开启爱情岛的精彩旅程。</p>
<h3>第一步：访问官方入口</h3>
<p>首先，请通过本导航页提供的官方入口访问爱情岛平台。确保您访问的是官方网站，以保障账户安全。</p>
<h3>第二步：填写注册信息</h3>
<p>在首页点击"注册"按钮，进入注册页面后，您需要填写以下信息：</p>
<ul>
<li>手机号码：用于接收验证码和账户安全验证</li>
<li>设置密码：建议使用字母、数字和符号的组合</li>
<li>昵称：这是您在平台上的显示名称</li>
<li>性别和年龄：用于匹配算法的基本参数</li>
</ul>
<h3>第三步：完善个人资料</h3>
<p>注册成功后，建议您完善个人资料，包括上传头像、填写兴趣爱好和个人简介等。完整的个人资料有助于提高匹配质量，让您更快找到志同道合的朋友。</p>
<h3>第四步：开始使用</h3>
<p>完成以上步骤后，您就可以开始浏览和互动了。建议先熟悉平台的基本功能布局，再逐步探索更多高级功能。</p>`,
    category: "guide",
    date: "2024-11-20",
    readTime: "4分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: "art-4",
    slug: "aiqingdao-backup-urls-explained",
    title: "爱情岛备用地址详解——为什么要使用多个访问入口",
    excerpt: "全面解析爱情岛设置多个备用访问地址的原因，以及在不同场景下如何选择最优的访问方式。",
    content: `<h2>爱情岛备用地址详解</h2>
<p>很多用户好奇为什么爱情岛需要设置多个备用访问地址。本文将为您详细解释背后的原因和使用技巧。</p>
<h3>为什么需要备用地址</h3>
<p>由于不同地区的网络环境和运营商策略存在差异，单一访问入口在某些情况下可能出现无法访问的情况。设置多个备用地址可以有效应对这类问题，确保用户在任何网络环境下都能顺利访问平台。</p>
<h3>备用地址的工作原理</h3>
<p>备用地址通过不同的网络线路和域名解析方式连接到同一服务器，用户在访问备用地址时获得的是与官方入口完全一致的服务体验。所有备用地址均经过严格的安全验证，用户可以放心使用。</p>
<h3>如何选择最优访问方式</h3>
<p>我们建议用户优先尝试官方主入口，如果遇到访问缓慢或无法连接的情况，再依次尝试备用地址。通常来说，距离您地理位置最近的线路会提供最快的访问速度。您也可以将多个地址都添加到浏览器书签中，方便快速切换。</p>`,
    category: "latest-url",
    date: "2024-11-15",
    readTime: "4分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: "art-5",
    slug: "account-security-best-practices",
    title: "爱情岛账户安全防护最佳实践",
    excerpt: "保护您的爱情岛账户安全的完整方案，包括密码管理、设备安全和隐私设置等全方位建议。",
    content: `<h2>爱情岛账户安全防护最佳实践</h2>
<p>账户安全是您在爱情岛上愉快体验的基础。本文将为您提供一套完整的账户安全防护方案。</p>
<h3>密码安全</h3>
<p>设置一个强密码是保护账户的第一道防线：</p>
<ul>
<li>密码长度至少8位，包含大小写字母、数字和特殊符号</li>
<li>不要使用生日、手机号等容易被猜测的信息作为密码</li>
<li>避免在多个平台使用相同的密码</li>
<li>建议每3-6个月更换一次密码</li>
</ul>
<h3>设备安全</h3>
<p>确保您访问爱情岛所使用的设备也是安全的：</p>
<ul>
<li>不要在公共电脑或他人设备上保存登录信息</li>
<li>使用完毕后及时退出登录</li>
<li>保持操作系统和浏览器更新到最新版本</li>
<li>安装可靠的安全防护软件</li>
</ul>
<h3>隐私设置建议</h3>
<p>合理配置隐私设置可以更好地保护您的个人信息：</p>
<ul>
<li>根据需求调整个人资料的可见范围</li>
<li>谨慎处理陌生人发来的链接和文件</li>
<li>不要在聊天中透露过多个人敏感信息</li>
<li>定期检查账户的登录设备和登录记录</li>
</ul>`,
    category: "safety",
    date: "2024-11-08",
    readTime: "5分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: "art-6",
    slug: "common-connection-issues-solutions",
    title: "访问爱情岛常见连接问题及解决方案汇总",
    excerpt: "整理用户反馈最多的访问问题，提供详细的排查步骤和解决方案，帮您快速恢复访问。",
    content: `<h2>访问爱情岛常见连接问题及解决方案</h2>
<p>在访问爱情岛的过程中，偶尔可能会遇到一些连接问题。本文汇总了最常见的几种情况及对应的解决方案。</p>
<h3>问题一：页面加载缓慢</h3>
<p>如果您发现页面加载速度很慢，可以尝试以下方法：</p>
<ul>
<li>清除浏览器缓存和Cookie后重新访问</li>
<li>更换浏览器尝试（推荐使用Chrome或Edge）</li>
<li>尝试切换到其他备用地址</li>
<li>检查本地网络连接速度</li>
</ul>
<h3>问题二：提示"无法连接到服务器"</h3>
<p>这种情况通常与网络环境有关，建议：</p>
<ul>
<li>切换网络环境（如从WiFi切换到移动数据）</li>
<li>尝试使用不同的备用地址</li>
<li>重启路由器和调制解调器</li>
<li>如持续无法访问，请联系客服获取帮助</li>
</ul>
<h3>问题三：验证码无法显示或接收</h3>
<p>如果遇到验证码相关的问题：</p>
<ul>
<li>刷新页面后重新获取验证码</li>
<li>检查手机是否屏蔽了短信通道</li>
<li>确保手机号码输入正确</li>
<li>等待60秒后重新尝试获取</li>
</ul>`,
    category: "faq",
    date: "2024-10-30",
    readTime: "4分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: "art-7",
    slug: "aiqingdao-new-features-2024",
    title: "爱情岛2024年新功能介绍——更智能的匹配体验",
    excerpt: "全面盘点爱情岛2024年新增的功能和改进，了解平台最新动态，充分体验每一项新特性。",
    content: `<h2>爱情岛2024年新功能介绍</h2>
<p>2024年，爱情岛平台进行了多次重大更新，引入了一系列新功能来提升用户体验。本文将为您详细盘点这些变化。</p>
<h3>智能匹配算法升级</h3>
<p>全新的AI匹配引擎能够更准确地分析用户的兴趣偏好和行为模式，匹配精准度相比之前提升了40%。系统会综合考虑用户的兴趣爱好、生活方式、价值观等多个维度，为您推荐更合适的交流对象。</p>
<h3>视频互动功能</h3>
<p>新增的视频通话功能让用户可以在平台上直接进行面对面的交流。该功能采用端到端加密技术，确保通话内容的安全性和私密性。</p>
<h3>社区广场</h3>
<p>全新上线的社区广场板块为用户提供了更丰富的互动场景。您可以在广场上发布动态、参与话题讨论、分享生活点滴，与更多志同道合的人建立联系。</p>
<h3>界面全面焕新</h3>
<p>用户界面经过重新设计，采用了更加简洁直观的布局，操作流程更加流畅。同时新增了深色模式，在夜间使用时更加护眼。</p>`,
    category: "guide",
    date: "2024-10-18",
    readTime: "4分钟",
    isHot: true,
    isNew: false,
  },
  {
    id: "art-8",
    slug: "mobile-app-download-guide",
    title: "爱情岛APP官方下载与安装指南",
    excerpt: "提供爱情岛官方APP的安全下载渠道和安装教程，确保您获得正版应用，享受流畅的移动端体验。",
    content: `<h2>爱情岛APP官方下载与安装指南</h2>
<p>为了给用户提供更便捷的移动端体验，爱情岛推出了官方APP。本文将指导您如何安全地下载和安装正版应用。</p>
<h3>官方下载渠道</h3>
<p>请务必通过以下官方渠道下载爱情岛APP：</p>
<ul>
<li>通过本导航页提供的官方下载链接</li>
<li>在官方应用商店（App Store / 各大安卓应用市场）搜索"爱情岛"</li>
<li>通过官方网站首页的二维码扫码下载</li>
</ul>
<h3>安装注意事项</h3>
<p>在安装过程中请注意：</p>
<ul>
<li>安卓用户可能需要开启"允许安装未知来源应用"的权限</li>
<li>iOS用户请确保Apple ID已登录且网络连接正常</li>
<li>安装包大小约为150MB，建议在WiFi环境下下载</li>
<li>安装完成后建议立即更新到最新版本</li>
</ul>
<h3>安全提醒</h3>
<p>请勿通过以下渠道获取安装包：</p>
<ul>
<li>网页弹窗中的下载链接</li>
<li>社交媒体私信中的安装包文件</li>
<li>第三方下载站或论坛提供的安装包</li>
</ul>`,
    category: "guide",
    date: "2024-10-05",
    readTime: "3分钟",
    isHot: false,
    isNew: false,
  },
  {
    id: "art-9",
    slug: "why-cant-access-aiqingdao",
    title: "为什么有时无法访问爱情岛？深度解析原因与对策",
    excerpt: "深入分析导致爱情岛无法访问的各种原因，并提供切实可行的解决方案，让您不再为访问问题困扰。",
    content: `<h2>为什么有时无法访问爱情岛？</h2>
<p>不少用户反映在某些时候无法正常访问爱情岛。本文将深入分析可能的原因并提供相应的解决方案。</p>
<h3>常见原因分析</h3>
<ul>
<li><strong>DNS解析问题：</strong>本地DNS服务器可能未能正确解析域名，导致无法找到服务器。可以尝试更换DNS服务器设置。</li>
<li><strong>网络运营商限制：</strong>部分网络运营商可能会对特定类型的网站实施访问限制，不同地区和运营商的策略不同。</li>
<li><strong>浏览器缓存问题：</strong>过期的浏览器缓存可能导致页面加载异常，清除缓存后通常可以解决。</li>
<li><strong>服务器维护：</strong>平台会定期进行系统维护，期间可能出现短暂无法访问的情况。</li>
</ul>
<h3>解决方案汇总</h3>
<ul>
<li>优先尝试切换备用地址进行访问</li>
<li>更换网络环境（切换WiFi/移动数据）</li>
<li>清除浏览器缓存和DNS缓存</li>
<li>更换浏览器或使用无痕模式</li>
<li>修改DNS服务器地址为公共DNS（如114.114.114.114）</li>
</ul>`,
    category: "faq",
    date: "2024-09-22",
    readTime: "4分钟",
    isHot: true,
    isNew: false,
  },
];

export const aboutContent = {
  brandName: "爱情岛网址导航",
  brandIntro: "爱情岛网址导航是专注于为爱情岛用户提供官方入口导航、安全访问指南和使用教程的专业服务平台。自成立以来，我们始终坚持以用户需求为导向，致力于为广大用户提供最准确、最及时、最安全的网址导航服务。",
  mission: "我们的使命是让每一位爱情岛用户都能轻松、安全地访问平台，不再为找不到正确网址而困扰。",
  vision: "成为最受用户信赖的爱情岛网址导航平台，持续为用户创造价值。",
  values: [
    { title: "准确可靠", description: "所有网址均经过严格验证，确保100%指向官方平台" },
    { title: "及时更新", description: "30分钟内响应地址变更，保持信息实时有效" },
    { title: "用户至上", description: "急用户之所急，7×24小时全天候提供服务支持" },
    { title: "安全第一", description: "将用户的信息安全和访问安全放在首位" },
  ],
  contact: {
    workingHours: "周一至周日 9:00 - 21:00",
    responseTime: "通常30分钟内回复",
  },
  stats: [
    { value: "3年+", label: "稳定运营" },
    { value: "500万+", label: "服务用户" },
    { value: "99.9%", label: "网址可用率" },
    { value: "100%", label: "用户满意度" },
  ],
};